import { atom } from "jotai";

export const MedicinePageAtom = atom(1);
export const MedicinePageSizeAtom = atom(10);
